<template>
  <v-container fluid>
    <v-skeleton-loader v-if="isLoadingPage" type="card"></v-skeleton-loader>
    <v-row v-else class="fill-height">
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center bg-container"
      >
        <v-card width="400" class="pa-5">
          <v-card-text class="d-flex justify-center mt-n3">
            <div class="avatar-container">
              <v-img
                src="https://img.freepik.com/free-vector/user-circles-set_78370-4704.jpg"
                class="avatar"
              ></v-img>
            </div>
          </v-card-text>

          <h2 class="text-h5 font-weight-bold text-center mb-5 mt-n3">
            Welcome Back
          </h2>
          <p class="mt-n4 mb-3 text-primary text-caption">
            Sign in with your account
          </p>

          <v-form @submit.prevent="userLogin">
            <v-text-field
              v-model="userName"
              label="Username"
              variant="outlined"
              dense
              prepend-inner-icon="mdi-account"
              class="mb-1"
              :error="userNameError"
              :error-messages="userNameErrorMessage"
              @input="clearError('userName')"
            ></v-text-field>

            <v-text-field
              v-model="userPass"
              label="Password"
              type="password"
              variant="outlined"
              dense
              prepend-inner-icon="mdi-lock"
              hide-details
              :error="userPassError"
              :error-messages="userPassErrorMessage"
              @input="clearError('userPass')"
            ></v-text-field>

            <div class="forgot-password">
              <a href="/quen-mat-khau">Forgot password?</a>
            </div>

            <v-btn
              block
              :loading="loading"
              color="primary"
              type="submit"
              elevation="2"
              >Log in</v-btn
            >
          </v-form>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="6"
        class="d-none d-md-flex align-center justify-center"
      >
        <v-img
          src="https://img.freepik.com/free-vector/privacy-policy-concept-illustration_114360-7853.jpg"
          max-width="500"
        ></v-img>
      </v-col>
    </v-row>

    <!-- Snackbar thông báo đăng nhập thành công -->
    <v-snackbar
      location="top center"
      v-model="successSnackbar"
      timeout="3000"
      color="success"
    >
      Đăng nhập thành công!
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "../utils/axios";
import VueCookies from "vue-cookies";
import { parse } from "tldts";

export default {
  name: "LoginComponent",
  data() {
    return {
      isLoadingPage: false,
      loading: false,
      user: null,
      userName: "",
      userPass: "",
      userNameError: false,
      userPassError: false,
      userNameErrorMessage: "",
      userPassErrorMessage: "",
      successSnackbar: false,
    };
  },
  watch: {},
  async created() {
    // Kiểm tra nếu đã đăng nhập thì chuyển hướng về trang quản lý người dùng
    // const token = VueCookies.get("auth");
    this.isLoadingPage = true;
    this.user = await this.getUserInfo();
    if (this.user) {
     
      const redirectUrl = new URLSearchParams(window.location.search).get(
        "redirect"
      );
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        if (this.user.Permission) {
          window.location.href = "/quan-ly-nguoi-dung"; // fallback
        } else {
          window.location.href = "/user-info"; // fallback
        }
       
      }
    }
    this.isLoadingPage = false;
  },
  methods: {
    clearError(field) {
      if (field === "userName") {
        this.userNameError = false;
        this.userNameErrorMessage = "";
      } else if (field === "userPass") {
        this.userPassError = false;
        this.userPassErrorMessage = "";
      }
    },

    async getUserInfo() {
      // Hàm này có thể được sử dụng để lấy thông tin người dùng sau khi đăng nhập thành công
      // Ví dụ: gọi API để lấy thông tin người dùng và lưu vào state hoặc localStorage
      if (!VueCookies.isKey("auth")) {
        return null; // Chưa đăng nhập
      }
      const kq = await axios.post("/User_Info")
      return kq.data[0];
    },

    getRootDomain() {
      const parsed = parse(window.location.hostname);
      return parsed.domain;
    },
    async userLogin() {
      this.loading = true;
      this.userNameError = false;
      this.userPassError = false;
      this.userNameErrorMessage = "";
      this.userPassErrorMessage = "";

      if (!this.userName) {
        this.userNameError = true;
        this.userNameErrorMessage = "Please enter your username.";
      }
      if (!this.userPass) {
        this.userPassError = true;
        this.userPassErrorMessage = "Please enter your password.";
      }
      if (this.userNameError || this.userPassError) {
        return;
      }

      try {
        const response = await axios.post(
          "https://api.udf.com.vn/user/login/",
          {
            username: this.userName,
            password: this.userPass,
          }
        );

        // localStorage.setItem("auth", response.data.token);
        // Set cookie với domain chính
        const domain = this.getRootDomain();

        VueCookies.set(
          "auth", // Tên cookie
          response.data.token, // Giá trị
          "365d", // Thời gian sống
          "/", // Path (root)
          domain // Domain chính → cho phép chia sẻ giữa các subdomain
        );

        this.successSnackbar = true;
        // this.$message("Đăng nhập thành công!", "success");
        const redirectUrl = new URLSearchParams(window.location.search).get(
          "redirect"
        );
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          window.location.href = "/quan-ly-nguoi-dung"; // fallback
        }
        // setTimeout(() => {
        //   this.loading = false;
        //   location = "/quan-ly-nguoi-dung";
        // }, 1500);
      } catch (error) {
        console.error("Login error:", error);
        this.userNameError = true;
        this.userPassError = true;
        this.userNameErrorMessage = "Incorrect username or password.";
        this.userPassErrorMessage = "Incorrect username or password.";
      } finally {
        this.loading = false;
      }
      // this.loading = false;
    },
  },
};
</script>


<style scoped>
a {
  font-weight: bold;
  cursor: pointer;
}

.avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  /* Giữ đúng kích thước */
  height: 100px;
  /* Giữ đúng kích thước */
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Đảm bảo ảnh không bị méo */
}

.bg-container {
  background-color: #f5f5f5;
  /* Màu nền xám nhạt */
  min-height: 100vh;
  /* Đảm bảo full màn hình */
}

.forgot-password {
  text-align: right;
  margin-top: 8px;
  margin-bottom: 8px;
}

.forgot-password a {
  text-decoration: none;
  color: #333;
  /* Màu tối hơn */
  font-size: 14px;
  font-weight: 500;
  /* Đậm hơn một chút */
  transition: color 0.3s ease-in-out;
}

.forgot-password a:hover {
  color: #007bff;
  /* Khi hover sẽ đổi màu xanh */
  text-decoration: underline;
}
</style>
